export * from './WidgetConfig';
